import { cn } from '@/customer/lib/utils'

import type { FieldLayoutProps } from './form-layout-context'

/**
 * Stacked layout: Label → Control → Description → Error
 *
 * Description sits below the control as help text. This keeps inputs
 * aligned across grid rows even when some fields have a description and
 * others don't - the mismatched space falls under the row rather than
 * pushing the input down.
 */
export function StackedLayout({ label, description, control, error, className }: FieldLayoutProps) {
  return (
    <div className={cn('flex min-w-0 flex-col gap-2.5', className)}>
      {label}
      {control}
      {description}
      {error}
    </div>
  )
}
